export default __webpack_public_path__ + "static/media/pastor.2b3ab11e.jpg";